export type CertificationTab<TTab extends string> = {
  id: TTab;
  label: string;
  count: number;
};

type Props<TTab extends string> = {
  tabs: CertificationTab<TTab>[];
  activeTab: TTab;
  onChange: (tab: TTab) => void;
  ariaLabel: string;
};

export function CertificationTabs<TTab extends string>({
  tabs,
  activeTab,
  onChange,
  ariaLabel,
}: Props<TTab>) {
  return (
    <div className="iso27001-tabs" role="tablist" aria-label={ariaLabel}>
      {tabs.map((tab) => (
        <button
          key={tab.id}
          type="button"
          role="tab"
          aria-selected={activeTab === tab.id}
          className={activeTab === tab.id ? "active" : ""}
          onClick={() => onChange(tab.id)}
        >
          {tab.label}
          <span>{tab.count}</span>
        </button>
      ))}
    </div>
  );
}
